<template>
  <v-container fluid>
  <v-form ref="form"
          v-model="valid"
          lazy-validation
          v-if="languageData.registerForm && languageData.labels"
  >
    <div class="d-flex justify-center">
      <div class="flex-column login-form-wrapper">
        <v-col>
          <p class="login-slogan display-2 text-center font-weight-medium mt-10">{{ languageData.registerForm.headFirst }}</p>
          <p class="login-slogan display-1 text-center font-weight-medium mb-1">{{ languageData.registerForm.headSecond }}</p>
        </v-col>
          <v-col>
            <v-row>
              <v-col cols="6">
                <v-text-field
                    v-model="data.firstname"
                    :rules="this.rules.firstname"
                    :label="languageData.labels.firstname"
                    single-line
                    required></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model="data.lastname"
                    :rules="this.rules.lastname"
                    :label="languageData.labels.lastname"
                    single-line
                    required></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
                v-model="data.email"
                :rules="this.rules.email"
                :label="languageData.labels.email"
                single-line
                required></v-text-field>
            <v-text-field
                light
                v-model="data.password"
                :rules="this.rules.password"
                single-line
                type="password"
                :label="languageData.labels.password"
                autocomplete="on"
                required ></v-text-field>
            <v-text-field
                light
                v-model="data.password_confirmation"
                :rules="this.rules.password_confirmation"
                single-line
                type="password"
                :label="languageData.labels.password_confirmation"
                autocomplete="on"
                required></v-text-field>
          </v-col>
          <v-col style="padding-top: 0 !important">
            <v-col cols="12" style="padding-top: 0 !important; padding-bottom: 0 !important">
              <v-checkbox
                v-model="data.agreementFirst"
                :value="true"
                :rules="[v => !!v]"
              >
                <template v-slot:label>
                  <p class="caption" style="line-height: 20px"><span>{{ languageData.registerForm.agreementFirst }}</span><a v-on:click.stop href="#" @click="openAffiliateContractModal">{{ languageData.registerForm.termsAndConditions }}</a><span>{{ languageData.registerForm.restOfAgreementFirst }}</span></p>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" style="margin-top: -25px; padding-top: 0 !important; padding-bottom: 0 !important">
              <v-checkbox
                v-model="data.agreementSecond"
                :value="true"
                :rules="[v => !!v]"
              >
                <template v-slot:label>
                  <p class="caption" style="line-height: 20px"><span>{{ languageData.registerForm.agreementSecond }}</span><a v-on:click.stop href="https://support.einklick.net/knowledgebase/datenschutzerklärung">{{ languageData.registerForm.dataProtection }}</a><span>{{ languageData.registerForm.restOfAgreementSecond }}</span></p>
                </template>
              </v-checkbox>
            </v-col>
            <v-col class="d-flex justify-space-between">
              <v-btn
                color="primary"
                class="button-shadow mr-4"
                :loading="regIsFetching"
                @click="register">
              {{ languageData.registerForm.btnText }}
            </v-btn>
            </v-col>  
          </v-col>
      </div>
    </div>
    </v-form>
    <ModalInfo :headModal="modalData.headInfoRegister" :typeInfo="modalData.typeInfoRegister" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isUserRegister" :text-modal="modalData.textInfoRegister"></ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideAffiliateContractModal"  :show-modal="isAffiliateContractModalVisible">
      <template v-slot:body>
        <v-row justify="center"><p style="font-size: 18px; font-weight: 700; margin-left: 50px; margin-right: 50px;">{{ 'Vereinbarung im Rahmen des Partnerprogramms' }}</p></v-row>
        <v-row><p style="margin-left: 50px; margin-right: 50px;">Abgeschlossen zwischen dem Partner und der TYCZYNSKI Construction UG mit sitzt in 76131 Karlsruhe, Ludwig-Erhard-Allee 10, Deutschland (Administrator)</p></v-row>
        <v-row justify="start">    
           <ol style="">
            <li>Der Nutzer schließt diesen Vertrag in elektronische Form ab. Der Vertrag kommt mit der Registrierung im ICT-System unter affiliate.einklick.net zustande</li>
            <li>Im Rahmen dieser Vereinbarung stellt der Administrator dem Partner "Referenzlinks" oder andere Werbe- und Verkaufsförderungsmaterialien zur Verfügung, die verwendet werden, um andere Internetbenutzer auf die Website einklick.net umzuleiten.</li>
            <li>Der Partner darf Links posten und an andere Nutzer weiterleiten in jeder Form und in jeder Weise auch unter Verwendung von QR-Codes, unter Verwendung von Java, HTML, PHP und anderen Codes, solange sie die Nutzer nicht über die Ziel-URL irreführen und Sein Inhalt.</li>
            <li>Der Verweislink darf in Form einer E-Mail an viele Nutzer gleichzeitig übermittelt werden, wenn die Empfängeradressen gesetzeskonform verwendet werden.</li>
            <li>Es ist verboten, Roboter zu verwenden, die automatische Konten erstellen, Links zwischen erotischen oder faschistischen Inhalten setzen und einen Link unter dem Text hinterlegen, der auf andere Inhalte als die Inhalte von einklick.net hinweist</li>
            <li>Der Administrator erfasst Nutzer, die sich für die auf einklick.net verfügbaren Programme über den Referenzlink des Partners registriert haben und ordnet diese Nutzer diesem Partner dauerhaft zu.</li>
            <li>Der Partner erhält am Ende eines jeden Kalendermonats eine aktuelle Liste der zugeordneten Nutzer und den Wert der von ihm getätigten Einkäufe. Die Abrechnung erfolgt spätestens am 10. des Monats des Vormonats. Die Erklärung wird ausschließlich in elektronischer Form an die bei der Registrierung angegebene E-Mail-Adresse gesendet. Der Administrator versendet die Listen nicht, wenn sie keine Werte enthalten (kein Verkauf)</li>
            <li>Der Wert der Einkäufe ist der Wert der geleisteten Nettozahlungen.</li>
            <li>Der Partner erhält für jeden getätigten Verkauf eine Vergütung in folgender Höhe: <br>
              Bei Verkauf bis zu 1000,- € netto /Monat - 15 % netto des Nettoverkaufswertes,
              Bei Verkauf über 1000,- € bis zu 2500,-€ netto/Monat - 20 % netto des Nettoumsatzes 
              Bei Verkauf über 2.500 € netto pro Monat – 25% netto des Nettoumsatzes. 
              Die einKlick.net-Software wird in Form eines Abonnements bezahlt. Der Partner erhält für jede Zahlung des Nutzers ohne zeitliche Begrenzung eine Provision.
              Für die alleinige Registrierung des Nutzers und für die Zeiten, in denen der Nutzer einen Account hat, zahlt aber kein Entgelt (Account inaktiv) und für die Nutzung kostenloser Software erhält der Partner keine Vergütung. 
              Die Vergütung wird aufgrund einer an die E-Mail-Adresse rechnung@tyczynski-construction.de gesendeten Rechnung innerhalb von 7 Tagen ab Datum einer ordnungsgemäß ausgestellten Rechnung gezahlt. Die Rechnung sollte enthalten: Angaben zum Verkäufer und Steuernummer, Angaben zum Empfänger, Produktbeschreibung [Affiliate EinKlick.net, Berichts-Nr. (Listennummer gemäß Punkt 7), Zeitraum, auf den sich der Verkauf bezieht, sonstige Daten nach § …. . UstG und eine gültige Kontonummer bei einer deutschen Bank</li>
            <li>Der Partner kann ein Bankkonto in einem anderen EU-Mitgliedstaat angeben. In einem solchen Fall verlängert sich die Zahlungsfrist auf 14 Tage</li>
            <li>Der Administrator kann den Provisionswert um 3 € netto kürzen, wenn der Provisionswert den Betrag von 100 € nicht übersteigt; in Höhe von 7 € netto bei Überweisung auf das unter Punkt 10 angegebene Bankkonto</li>
            <li>Der Partner ist nicht verpflichtet, die im Kalenderjahr berechnete Provision zu auszahlen. In einem solchen Fall wird die Provision berechnet und akkumuliert bis zur Zahlung oder bis zum 31. Dezember.</li>
            <li>Der Partner ist verpflichtet, die ihm zustehende Provision für ein bestimmtes Kalenderjahr zu auszahlen. Die Rechnung soll bis spätestens 31. Januar des Folgejahres ausgestellt und zugestellt werden. Nach Ablauf dieser Frist verfällt die Partnerprovision an den Administrator.</li>
            <li>Der Administrator hat das Recht, das Konto des Partners zu schließen, wenn er gegen die Vertragsbedingungen verstößt, gegen das Spam-Verbot bei der Verteilung von Referenzlinks verstößt oder Werbetechniken anwendet, die gemeinhin als unethisch gelten. Eine Kontoschließung kann auch erfolgen, wenn der Partner über einen Zeitraum von 4 Monaten keine Umsätze erzielt hat oder über einen Zeitraum von 12 Monaten der Wert der Provision den durchschnittlichen Betrag von 10 € pro Monat nicht übersteigt.</li>
            <li>Der Administrator hat das Recht, dem Administrator automatische Systembenachrichtigungen sowie Werbe- und Verkaufsförderungsmaterialien zu senden, um seine Wirksamkeit zu erhöhen. Dies gilt auch für Einladungen zur Teilnahme an Seminaren, Schulungen und Webinaren.</li>
            <li>Der Administrator ist nicht verantwortlich für die falsche Zuordnung des Benutzers zum Partner, die sich aus den technischen Möglichkeiten von IKT-Systemen ergibt.</li>
            <li>In Angelegenheiten, die nicht Inhalt dieses Vertrages sind, gelten ausschließlich die Bestimmungen des deutschen Rechts</li>
           </ol>
        </v-row>
      </template>
    </ModalInfo>
  </v-container>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";

  export default {
    name: "RegisterForm",
    created() {
      eventBus.$on("failureRegister", (errorsData) => {
        this.rules = handleFormError(errorsData);

        this.$refs.form.validate();
      });
      eventBus.$on("resetFormValidation", this.resetForm);
    },
    data() {
      return {
          data: {},
          valid: false,
          rules: {},
          isAffiliateContractModalVisible: false,
      }
    },
    components: {
      ModalInfo
    },
    computed: {
      ...mapState('registerMain', {
        regIsFetching: state => state.isFetching,
        modalData: state => state.modalData,
        isUserRegister: state => state.isUserRegister
      } )
    },
    methods: {
      ...mapActions('registerMain', ['registerUser', 'updateVisibleModal']),
      register: function() {
        this.data.language = this.language;
        this.rules = [];
        this.$refs.form.resetValidation();
        this.registerUser({ creds: this.data });
      },
      hideModal: function() {
        this.updateVisibleModal(false);
      },
      resetForm: function() {
        this.$refs.form.resetValidation();
      },
      openAffiliateContractModal() {
        this.isAffiliateContractModalVisible = true;
      },
      hideAffiliateContractModal() {
        this.isAffiliateContractModalVisible = false;
      }
    },
  }
</script>
<style lang="scss">
  ol {
    text-align: justify; 
    margin-left: 50px;
    margin-right: 50px;
  }
  ol li {
    padding-left: 10px; 
    margin-bottom: 10px; 
    line-height: 24px
  }
</style>